module.exports = "<a *ifLoggedIn class=\"btn btn-outline-primary\" [routerLink]=\"['/object/edit-html', id]\">Edit this section</a>\n<div [innerHTML]=\"html\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /var/snowriders/app/src/app/html-object.component.html
// module id = ../../../../../src/app/html-object.component.html
// module chunks = main